<template>
  <modal
    title="Add New Terminal"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="my-3 font-semibold">
      Add a new terminal where your organization office can be found.
    </div>
    <form class="flex flex-col gap-4 mt-2">
      <div class="new-location-form__single-input-wrapper">
        <label class="label">Terminal Name</label>
        <input type="text" class="input" v-model="newLocation.locationName" />
      </div>
      <div class="new-location-form__single-input-wrapper">
        <label class="label">Address</label>
        <vue-google-autocomplete
          id="map2"
          ref="shipperAddress"
          :value="newLocation.address"
          classname="input"
          placeholder="Enter address"
          v-on:placechanged="getAddress"
        >
        </vue-google-autocomplete>
      </div>
      <div class="new-location-form__single-input-wrapper">
        <label class="label">Country</label>
      
        <input type="text" class="input" v-model="newLocation.country" />
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">State</label>
               <input type="text" class="input" v-model="newLocation.state" />

      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">City</label>
               <input type="text" class="input" v-model="newLocation.city" />
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">ZIP Code</label>
        <input type="text" class="input" v-model="zipCode" />
      </div>
    </form>
    <p
      v-if="newLocation.locationManager == null"
      class="flex gap-2 text-primary-green my-4 cursor-pointer items-center"
      @click="showLocationManager = true"
    >
      <span>
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="#09B78A"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.45312 5.6543V7.3125H5.80273C5.72266 7.3125 5.65625 7.37305 5.65625 7.44922V8.26953C5.65625 8.34375 5.72266 8.40625 5.80273 8.40625H7.45312V10.0645C7.45312 10.1406 7.51562 10.2031 7.58984 10.2031H8.41016C8.48633 10.2031 8.54688 10.1406 8.54688 10.0645V8.40625H10.1973C10.2773 8.40625 10.3438 8.34375 10.3438 8.26953V7.44922C10.3438 7.37305 10.2773 7.3125 10.1973 7.3125H8.54688V5.6543C8.54688 5.57812 8.48633 5.51562 8.41016 5.51562H7.58984C7.51562 5.51562 7.45312 5.57812 7.45312 5.6543ZM15.1875 2.82812H8.17578L5.88477 0.636719C5.85562 0.609429 5.81727 0.594092 5.77734 0.59375H0.8125C0.466797 0.59375 0.1875 0.873047 0.1875 1.21875V12.7812C0.1875 13.127 0.466797 13.4062 0.8125 13.4062H15.1875C15.5332 13.4062 15.8125 13.127 15.8125 12.7812V3.45312C15.8125 3.10742 15.5332 2.82812 15.1875 2.82812ZM14.4062 12H1.59375V2H5.27539L7.61133 4.23438H14.4062V12Z"
            fill="#09B78A"
          />
        </svg>
      </span>
      Add Terminal manager
    </p>
    <div v-else class="new-location-form__single-input-wrapper">
      <div class="flex justify-between">
        <span class="label" for="manager">Terminal Manager</span>
        <button
          class="cursor-pointer hidden text-primary-yellow text-sm font-semibold"
          @click="showLocationManager = true"
        >
          Change Terminal Manager
        </button>
      </div>
      <div class="p-1 font-semibold">
        {{ locationManagerObj.firstname }} {{ locationManagerObj.lastname }}
      </div>
    </div>

    <div class="button-wrapper mt-5">
      <base-button
        text="Save"
        :loading="isLoading"
        :disabled="disableButton"
        @click="createLocation"
      />
      <p class="cursor-pointer pt-2 pr-3 mb-0" @click="closeModal">Cancel</p>
    </div>
    <add-location-manager-modal
      :showModal="showLocationManager"
      :users="users"
      @new-location-manager="updateManager"
      @close-modal="showLocationManager = false"
    />
  </modal>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import AddLocationManagerModal from "./AddLocationManagerModal";
export default {
  props: ["showModal"],
  components: {
    AddLocationManagerModal,
    VueGoogleAutocomplete,
  },
  data() {
    return {
      zipCode: "",
      isLoading:false,
      newLocation: {
        locationName: "",
        address: "",
        lat: "",
        long: "",
        country: "",
        state: "",
        city: "",
        orgId: localStorage.getItem("organizationId"),
        locationManager: null,
      },
      creatingLocation: false,
      states: [],
      cities: [],
      showLocationManager: false,
      countries: ["Nigeria"],
      locationManagerObj: {},
      users: [],
    };
  },
  watch: {
    "newLocation.state"(val) {
      this.cities = [];
      if (val?.length > 0) {
        this.cities = [
          ...this.states.find((state) => state.name == val).cities,
        ];
      }
    },
    "newLocation.lat"(val) {
      this.geoCoderPayload.lat = val;
    },
    "newLocation.long"(val) {
      this.geoCoderPayload.long = val;
      if(this.geoCoderPayload.lat && this.geoCoderPayload.long){
        this.getGeoCoder()
      }
    },
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newLocation);
    },
    geoCoderPayload() {
      return {
        lat: null,
        long: null,
      };
    },
  },
  mounted() {
    this.getAllStatesAndCities();
    this.getUsers();
  },
  methods: {
    async getGeoCoder() {
      try {
        const response = await this.$_getStateNameWithDim(this.geoCoderPayload);
        console.log(JSON.stringify(response.data, null, 2));
        // let geoData = response.data.address
        this.newLocation.country = response.data.country
        this.newLocation.state = response.data.state.replace(" State", "")
        this.newLocation.city = response.data.city
        this.zipCode =  response.data.zip
      } catch (error) {
        this.handleError();
      }
    },
    getAddress(addressData) {
      console.log(addressData, "gogole soem");
      this.newLocation.address = addressData.route;
      this.newLocation.lat = addressData.latitude;
      this.newLocation.long = addressData.longitude;
      this.shipper.country = addressData.country;
    },
    async getUsers() {
      try {
        let response = await this.$_getOrgUsers();
        console.log(response.data);
        this.users = response.data;
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
    async createLocation() {
      this.isLoading = true
      this.creatingLocation = true;
      this.newLocation.zipCode = this.zipCode;

      try {
        await this.$_createLocation(this.newLocation);
        this.creatingLocation = false;
        this.generateToast("Location successfully created!", "success");
        this.closeModal();
        this.$emit("added-location");
      } catch (error) {
        this.creatingLocation = false;
        this.handleError(error);
      }finally{
        this.isLoading=false
      }
    },
    resetInputFields() {
      this.newLocation = {
        locationName: "",
        type: "",
        address: "",
        country: "",
        state: "",
        city: "",
        zipcode: "",
      };
    },

    updateManager(user) {
      this.newLocation.locationManager = user.id;
      this.locationManagerObj = user;
    },

    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.row {
  padding-top: 1rem !important;
}

.kpa-summary {
  margin-top: 1rem;
}

.text-grey {
  color: #7a90a7;
}

li {
  list-style-type: initial !important;
  margin-left: 1rem;
  padding-top: 0.5rem;
}

.input {
  display: block;
  width: 100%;
  height: 2.75rem;
  margin-bottom: 0.5rem;
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
